/**
 * ChatBubble — один баббл сообщения.
 * Используется как в сценах 1-3 (внутри MessageCard), так и в лавине (сцена 4).
 *
 * variant:
 *   - 'received' — пришло от собеседника, белый фон, тень, выравнено влево
 *   - 'plain'    — для лавины, без хвостика, более компактный
 */
export default function ChatBubble({
  text,
  time,
  variant = 'received',
  className = '',
}: {
  text: string;
  time?: string;
  variant?: 'received' | 'plain';
  className?: string;
}) {
  if (variant === 'plain') {
    return (
      <div
        className={
          'inline-block bg-white rounded-2xl px-3 py-2 shadow-[0_2px_8px_rgba(20,30,20,0.08)] ' +
          'font-body text-[#161d16] text-sm leading-snug max-w-[260px] ' +
          className
        }
      >
        {text}
      </div>
    );
  }

  // 'received'
  return (
    <div
      className={
        'relative inline-block bg-white rounded-2xl rounded-bl-md px-4 py-3 ' +
        'shadow-[0_4px_16px_rgba(20,30,20,0.08)] font-body text-[#161d16] ' +
        'text-base leading-relaxed max-w-[320px] whitespace-pre-line ' +
        className
      }
    >
      {text}
      {time && (
        <span className="block text-xs text-[#7a8a79] mt-1 -mb-0.5 font-body">
          {time}
        </span>
      )}
    </div>
  );
}
